import React, { useState, useEffect } from 'react';
import { useParams,useNavigate } from 'react-router-dom';
import { TailSpin } from "react-loader-spinner";
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../../actions/auth';
import { Navbar } from '../ui/NavBar';
import {encode as base64_encode} from 'base-64';
import  { GetCourseInfo }  from '../../controllers/GetCourseInfo';
import  { ProgressInsert }  from '../../controllers/ProgressInsert';
import  { GetCourseChild }  from '../../controllers/GetCourseChild';
import  { GetQuestionById }  from '../../controllers/GetQuestionById';
import  { GetAnswersByQuestion }  from '../../controllers/GetAnswersByQuestion';
import transEs from '../../translate/es.json';
import transCat from '../../translate/cat.json';
import transDe from '../../translate/de.json';
import transEn from '../../translate/en.json';
import transFr from '../../translate/fr.json';
import transOt from '../../translate/ot.json';
import transPr from '../../translate/pr.json';
import  { PositionUpdate }  from '../../controllers/PositionUpdate';
import  { positionByCourse }  from '../../controllers/positionByCourse';
import { QuestionMultiple } from './QuestionMultiple';
import { QuestionVF } from './QuestionVF';
import { QuestionAlone } from './QuestionAlone';
import { QuestionEmp } from './QuestionEmp';

// Home to display "Pregunta"
export const QuestionScreen = () => {
    const dispatch = useDispatch();
    const history = useNavigate();
    const langTxt = localStorage.getItem('userLanguage') || 'es';
    let transTxt = transEs;
    if(langTxt === 'es'){
        transTxt = transEs;
    }
    else if(langTxt === 'cat'){
        transTxt = transCat;
    }
    else if(langTxt === 'de'){
        transTxt = transDe;
    }
    else if(langTxt === 'en'){
        transTxt = transEn;
    }
    else if(langTxt === 'fr'){
        transTxt = transFr;
    }
    else if(langTxt === 'pr'){
        transTxt = transPr;
    }
    else{
        transTxt = transOt;
    }

    const [questionDes, setQuestionDes] = useState("");
    const [audioQuestion, setAudioQuestion] = useState("");
    const [optionsQuestion, setOptionsQuestion] = useState("");
    const [typeQuestion, setTypeQuestion] = useState("");
    const [activeButton, setActiveButton] = useState(false);
    const [info, setInfo] = useState("");
    const [nameUnit, setNameUnit] = useState("");
    const cursoId = localStorage.getItem('courseId');
    const cursoColor = localStorage.getItem('courseColor');
    const courseColorThree = localStorage.getItem('courseColorThree');
    const [course, setCourse] = useState([]);
    const [cursoNombre, setCursoNombre] = useState('');
    const { fatherId } = useParams();
    const { unitId } = useParams();
    const { questionId } = useParams();
    const chapterId = (localStorage.getItem('chapterId'))?JSON.parse(localStorage.getItem('chapterId')):'';
    let user = useSelector( state => state.auth );
    const token = useSelector((state) => state.ui.token);
    if(!user?.id){
        if(sessionStorage.getItem('userSelect') && token){
            user = JSON.parse(sessionStorage.getItem('userSelect'));
        }
        else{
            dispatch(logout(token));
            history( '/auth/', {
            replace: true
            });
        }
    }

    let ran = false;
    useEffect(() => {
        if (ran) return;
            positionByCourse( token, user.id, cursoId)
            .then((e)=>{
                if(e.status === "Token is Expired"){
                    dispatch(logout(token));
                }
                // console.log({e})
                PositionUpdate( token, user.id, cursoId, `/question/${ fatherId }/${ unitId }/${ questionId }`, e[0].id)
                .catch((e)=>{
                    console.error(e);
                    dispatch(logout(token));
                });
            })
            .catch((e)=>{
                console.error(e);
                // dispatch(logout(token));
            });
            setActiveButton(true);
            
            GetQuestionById(questionId, user.languaje, token, user.id)
            .then((e)=>{
                if(e.status === "Token is Expired"){
                    dispatch(logout(token));
                }
                // console.log(e[0], user)
                setInfo(e[0])
                
                setTypeQuestion(e[0].question_type)
                if(e[0].progress_id === null ){
                    ProgressInsert(token, user.id, e[0].id, "question")
                    .catch((e)=>{
                        console.error(e);
                        //dispatch(logout(token));
                    });
                }
            })
            .catch((e)=>{
                console.error(e);
                // dispatch(logout(token));
            });
            GetAnswersByQuestion(questionId, user.languaje, token)
            .then((e)=>{
                if(e.status === "Token is Expired"){
                    dispatch(logout(token));
                }
                //console.log('answer',e)
                const duplicates = e.reduce((acc, current) => {
                    const existingElement = acc.find(item => item.id === current.id);
                    
                    if (!existingElement) {
                      acc.push(current);
                    }
                  
                    return acc;
                  }, []);
                setOptionsQuestion(duplicates)
            })
            .catch((e)=>{
                console.error(e);
                // dispatch(logout(token));
            });

            GetCourseChild(cursoId, user.languaje, token, user.id, fatherId)
            .then((e)=>{
                if(e.status === "Token is Expired"){
                    dispatch(logout(token));
                }
                let found = e.find(element => element.id === unitId);

                if(found?.progress_id === null ){
                     ProgressInsert(token, user.id, found.id )
                    .catch((e)=>{
                        console.error(e);
                        // dispatch(logout(token));
                    });
                }
                if(found?.text_value !== null && found?.text_value !== undefined){
                    setNameUnit(found.text_value)
                }
            })
            .catch((e)=>{
                console.error(e);
                // dispatch(logout(token));
            });

            GetCourseInfo(cursoId, user.languaje, token, user.id)
            .then((e)=>{
                if(e.status === "Token is Expired"){
                    dispatch(logout(token));
                }
                setCourse(e[0]);
                if(e[0]?.name){
                    setCursoNombre(e[0].name)
                }
            })
            .catch((e)=>{
                console.error(e);
                // dispatch(logout(token));
            });
        return () => (ran = true);
    }, [])

    const handlerClick = (e) => {
        let markedCheckboxOK = document.querySelectorAll('input[type="checkbox"]');
        let count = 0;
        for (let checkbox of markedCheckboxOK) {
            if(checkbox.value==="1"){
                count++
            }
        }
        let markedCheckbox = document.querySelectorAll('input[type="checkbox"]:checked');
        let countC = 0;
        let optId = [];
        for (let checkbox of markedCheckbox) {
            if(checkbox.value==="0"){
                countC = 0
                history( `/question-fail/${fatherId}/${unitId}/${questionId}`, {
                             replace: true
                 });
            }
            else{
                countC++
                optId.push(parseInt(checkbox.id))
            }
        }
        if(count === countC){
            history( `/question-ok/${fatherId}/${unitId}/${questionId}`, {
                replace: true
            });
        }
        else{
            history( `/question-fail/${fatherId}/${unitId}/${questionId}`, {
                replace: true
             });
        }
    };

    const handlerRadioClick = (e) => {
        let markedCheckboxOK = document.querySelectorAll('input[type="radio"]');
        let count = 0;
        for (let checkbox of markedCheckboxOK) {
            if(checkbox.value==="1"){
                count++
            }
        }
        let markedCheckbox = document.querySelectorAll('input[type="radio"]:checked');
        let countC = 0;
        let optId = [];
        for (let checkbox of markedCheckbox) {
            if(checkbox.value==="0"){
                countC = 0
                history( `/question-fail/${fatherId}/${unitId}/${questionId}`, {
                             replace: true
                 });
            }
            else{
                countC++
                optId.push(parseInt(checkbox.id))
            }
        }
        if(count === countC){
            history( `/question-ok/${fatherId}/${unitId}/${questionId}`, {
                replace: true
            });
        }
        
    };
    
    const handlerInfoClick = () => {

        history.replace('/questions/'+chapterId);

    };


    if(course===''){
        history.replace('/home');
    }
    
    const disCourse = ()=>{

        let questionType = 0;
        if(!isNaN(typeQuestion)){
            questionType = parseInt(typeQuestion);
        }
        
        if(questionType === 1){//'respuesta-sola'
            return QuestionAlone(optionsQuestion, handlerRadioClick, handlerInfoClick, cursoColor, transTxt, audioQuestion, activeButton)
            
        }
        else if(questionType === 2){//'respuesta-multiple'
            return QuestionMultiple(optionsQuestion, handlerClick, handlerInfoClick, cursoColor, transTxt, audioQuestion, activeButton);
            
        }
        else if(questionType === 3){ //'verdadero-falso'
            return QuestionVF(optionsQuestion, handlerRadioClick, handlerInfoClick, cursoColor, transTxt, audioQuestion, activeButton, questionDes);
            
        }
        else if(questionType === 4){ //'emparejar'
            return QuestionEmp(optionsQuestion, handlerInfoClick, cursoColor, transTxt, audioQuestion, activeButton, history, fatherId, unitId, questionId, questionDes);
            
        }
        
        
    }
    const parseHTML = (htmlString) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        const body = doc.body;
    
        return Array.from(body.childNodes).map((node, index) => {
        const key = `node_${index}`;
    
        if (node.nodeType === Node.ELEMENT_NODE) {
            // Crea componentes para las etiquetas HTML necesarias
            const tagName = node.tagName.toLowerCase();
    
            if (tagName === 'b' || tagName === 'strong') {
            return <strong key={key}>{parseHTML(node.innerHTML)}</strong>;
            } else if (tagName === 'p') {
            return <p key={key}>{parseHTML(node.innerHTML)}</p>;
            }
        } else if (node.nodeType === Node.TEXT_NODE) {
            // Renderiza el texto
            return node.nodeValue;
        }
    
        return null;
        });
    };

    const infoCourse = () => {
        let textV = info.text_value;
        if (textV === null) {
          textV = '';
        }
        try {
          return (info) ?
            <div key={info.id}>
              <div key="qmd" id="question-main-description" className="question-main-description" style={{
                backgroundColor: courseColorThree, whiteSpace: 'pre-line'
              }}>
                {
                  textV.split('\r\n').map((item, idx) => {
                    return (
                      <React.Fragment key={idx}>
                        {parseHTML(item)}
                        <br />
                      </React.Fragment>
                    );
                  })
                }
              </div>
              <div className="img-question-back">
                {
                  (info.image_value_type === "svg") ?
                    <img className="img-info" src={`data:image/${info.image_value_type}+xml;base64,${base64_encode(info.image_value)}`} alt={nameUnit} />
                    :
                    <img className="img-info" src={`data:image/${info.image_value_type}+xml;base64,${btoa(info.image_value)}`} alt={nameUnit} />
                }
              </div>
            </div>
            : null;
        } catch (e) {
      
          return (info) ?
            <div key={info.id}>
              <div id="question-main-description" className="question-main-description" style={{
                backgroundColor: courseColorThree, whiteSpace: 'pre-line'
              }}>
                {
                  textV.split('\r\n').map((item, idx) => {
                    return (
                      <React.Fragment key={idx}>
                        {parseHTML(item)}
                        <br />
                      </React.Fragment>
                    );
                  })
                }
              </div>
            </div>
            : null;
        }
      };

    return (
        <div className="fund-main-unit-q">
            <Navbar title={cursoNombre}/>
            <div className="text-title"
            style={{
                backgroundColor: cursoColor,
                color:  "#ffffff",
            }}
            >{nameUnit && nameUnit}</div>

            {
                course && (course.background_home_type==="svg")
                ?
                <img className="fund-start-b-imgu" src = {`data:image/svg+xml;base64,${base64_encode(course.background_home)}`} alt="Back Ground"/>
                :
                (course.background_home_type!==null)?
                <img className="fund-start-b-imgu" src = {`data:image/${course.background_home_type}+xml;base64,${btoa(course.background_home)}`} alt="Back Ground"/>
                :null
            }

            <div className="content-course" key="cc">
                {!course && <div className="loader-page" key="lk"><TailSpin
                    color="#00BFFF"
                    height={200}
                    width={200}
                />
                </div>} 
                {info && infoCourse() }
            </div>
            
            <div className="fund-main-question">
                <div className="content-questions" >
 
                <div className="container-question">
                {!optionsQuestion && <div className="loader-page"><TailSpin
                    color="#00BFFF"
                    height={200}
                    width={200}
                />
                </div>}
                    { optionsQuestion && disCourse() }
                </div>
                
                </div>
                
            </div>
        </div>
    )
}

